import promo from "../../Assests/vid/promo.mp4"
import Toolbar from "../navigation/toolbar/toolbar";
import Footer from "../navigation/footer/footer"

export default function Video() {
  return (
    <>
    <Toolbar />    
    <div style={{ textAlign: 'center', margin: '20px', color:'#ea7146' }}>
        <h3>Sain et équilibré, le couscous se mange au quotidien et à toutes saisons.</h3><br />
      <video width="750" height="500" autoPlay="true" controls>
        <source src={promo} type="video/mp4" />
        Ton navigateur ne supporte pas la balise vidéo.
      </video>
    </div>
    <Footer />
    </>

  );
}